import * as s from "../VideoShareStyled";
import { TableTemplate } from "components/templates/default/table/TableTemplate";

import SearchInput, {
  ClickSearch,
} from "components/atoms/input/search/SearchInput";
import StorageLabel from "components/blocks/storage/StorageLabel";
import { useRef } from "react";
import { IoChevronBackOutline, IoChevronForward } from "react-icons/io5";
import { ReactComponent as VIDEO_SHARE_ICON } from "assets/icons/videoshare_white.svg";
import * as mediaQuery from "components/MediaQuery";
import VideoSharePoster from "./VideoSharePoster";
import {
  VideoBasePagination,
  VideoShareFilter,
  VideoShareResult,
} from "api/interfaces/videoshareInterface.interface";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import Spinner from "components/atoms/loader/Spinner";
import NoData from "components/templates/nopage/NoData";
import { checkEmpty } from "utils/functions";

export type Props = {
  tagFilters: string[];
  videoList: VideoShareResult[];
  videoTotal: number;
  isStatusFilter: VideoShareFilter;
  onChangeStatusFilter: (value: string) => void;
  listQueryInfo: VideoBasePagination;
  onClickSearch: ClickSearch;
  selectedTag: string[];
  onClickTag: (item: string, event?: React.MouseEvent) => void;
  isSharePopup: string;
  onClickShare: (videoId: string, isOpen: boolean) => void;
  selectedAccount: ProfileAccountInfo;
  status: string;
};

export default function VideoSharePresenter(props: Props): JSX.Element {
  const horizontalScrollRef = useRef<any>(null);
  const centerChildren = (
    <>
      <mediaQuery.Mobile>
        <div className="storage-label-mobile">
          <StorageLabel />
        </div>
      </mediaQuery.Mobile>
    </>
  );

  const sub = (
    <>
      <mediaQuery.Default>
        <s.TitleRight>
          <s.SearchWrapper>
            <SearchInput
              onClickSearch={props.onClickSearch}
              keyword={props.listQueryInfo.keyword}
            />
          </s.SearchWrapper>
          <StorageLabel />
        </s.TitleRight>
      </mediaQuery.Default>

      <mediaQuery.Mobile>
        <SearchInput onClickSearch={props.onClickSearch} />
      </mediaQuery.Mobile>
    </>
  );

  const handleNextButtonClick = (nextType: "prev" | "next") => {
    if (nextType === "prev") {
      horizontalScrollRef.current.scrollTo({
        left:
          horizontalScrollRef.current.scrollLeft -
          horizontalScrollRef.current.offsetWidth,
        behavior: "smooth",
      });
    } else {
      horizontalScrollRef.current.scrollTo({
        left:
          horizontalScrollRef.current.scrollLeft +
          horizontalScrollRef.current.offsetWidth,
        behavior: "smooth",
      });
    }
  };

  const titleComponent = (
    <mediaQuery.Default>
      <s.TitleWrapper>
        <s.TitleComponent>
          <p className="icon">
            <VIDEO_SHARE_ICON />
          </p>
          Video Share
        </s.TitleComponent>
      </s.TitleWrapper>
    </mediaQuery.Default>
  );

  return (
    <s.Container>
      <TableTemplate
        titleComponent={titleComponent}
        centerChildren={centerChildren}
        noSearch
        buttons={sub}
      >
        <s.HeaderContainer>
          <s.RightFilter>
            <s.LeftScrollButton
              onClick={() => handleNextButtonClick("prev")}
              data-testid="videoshare-list-list-left-scroll-button-next-button"
            >
              <IoChevronBackOutline />
            </s.LeftScrollButton>
            <s.RightScrollButton
              onClick={() => handleNextButtonClick("next")}
              data-testid="videoshare-list-list-right-scroll-button-next-button"
            >
              <IoChevronForward />
            </s.RightScrollButton>
            <s.RightScroll ref={horizontalScrollRef}>
              <s.RightItem
                key={"video_tag_all"}
                isFilter={
                  props.selectedTag.includes("All") ||
                  props.selectedTag.length === 0
                }
                onClick={(e) => {
                  // e.stopPropagation();
                  props.onClickTag("All");
                }}
                data-testid="videoshare-list-list-right-item-click-tag"
              >
                {"All"}
              </s.RightItem>
              {props.tagFilters.map(
                (item, index) =>
                  item !== undefined &&
                  !checkEmpty(item) && (
                    <s.RightItem
                      key={"video_tag_" + index}
                      isFilter={props.selectedTag.includes(item)}
                      onClick={(e) => {
                        // e.stopPropagation();
                        props.onClickTag(item);
                      }}
                      data-testid="videoshare-list-list-right-item-click-tag-2"
                    >
                      {item}
                    </s.RightItem>
                  )
              )}
            </s.RightScroll>
          </s.RightFilter>
        </s.HeaderContainer>

        {props.status === "loading" ? (
          <Spinner />
        ) : props.videoList.length === 0 ? (
          <s.NoDataWrapper>
            <NoData />
          </s.NoDataWrapper>
        ) : (
          <s.Grid id="video-grid-container">
            {props.videoList?.map((item, index) => {
              return (
                <VideoSharePoster
                  key={`video_poster_${item.videoId}_${index}`}
                  item={item}
                  index={index}
                  selectedTag={props.selectedTag}
                  onModelVisible={props.isSharePopup === item.videoId}
                  onClickShare={props.onClickShare}
                  selectedAccount={props.selectedAccount}
                />
              );
            })}
          </s.Grid>
        )}
      </TableTemplate>
    </s.Container>
  );
}
